import axios from 'axios';

export type RegimeEmenda = 'map' | 'pendente' | 'direto';
export type StatusExecucao = 'indicado' | 'empenhado' | 'pago';

export interface AcaoEmenda {
  nome: string;
  valor: number;
  status: StatusExecucao;
}

export interface ExecucaoDireta {
  indicado: number;
  empenhado: number;
  pago: number;
}

export interface Emenda {
  id: string;
  tenant_id: string;
  codigo: string;
  titulo: string;
  bairro?: string;
  beneficiario?: string;
  exercicio: number;
  regime: RegimeEmenda;
  acoes: AcaoEmenda[];
  direto?: ExecucaoDireta;
  map_proposto: Array<{ nome: string; valor: number }>;
  // Consolidados pelo servidor: os estágios são cumulativos
  total_indicado: number;
  total_empenhado: number;
  total_pago: number;
  created_at: string;
  updated_at: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const emendasApi = {
  list: async (token: string, exercicio?: number) => {
    const res = await axios.get<Emenda[]>(`${API_URL}/gab/emendas`, {
      ...auth(token),
      params: exercicio ? { exercicio } : undefined,
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<Emenda>(`${API_URL}/gab/emendas/${id}`, auth(token));
    return res.data;
  },

  create: async (data: Partial<Emenda>, token: string) => {
    const res = await axios.post<Emenda>(`${API_URL}/gab/emendas`, data, auth(token));
    return res.data;
  },

  update: async (id: string, data: Partial<Emenda>, token: string) => {
    const res = await axios.put<Emenda>(`${API_URL}/gab/emendas/${id}`, data, auth(token));
    return res.data;
  },

  decidirRegime: async (id: string, decisao: 'migrar' | 'descartar', token: string) => {
    const res = await axios.post<Emenda>(
      `${API_URL}/gab/emendas/${id}/regime`,
      { decisao },
      auth(token),
    );
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/gab/emendas/${id}`, auth(token));
  },
};
